export const getMenuItems = (userRole) => {
  const ownerMenu = [
    { icon: 'fa-tachometer-alt', label: 'Dashboard', path: 'dashboard' },
    { icon: 'fa-ship', label: 'My Ships', path: 'my-ships' },
    { icon: 'fa-file-alt', label: 'Post a Job', path: 'post-job' },
    { icon: 'fa-list', label: 'My Jobs & Quotations', path: 'my-jobs-quotations' }
  ];

  const serviceProviderMenu = [
    { icon: 'fa-tachometer-alt', label: 'Dashboard', path: 'dashboard' },
    { icon: 'fa-briefcase', label: 'Available Jobs', path: 'available-jobs' },
    { icon: 'fa-file-invoice-dollar', label: 'My Quotations', path: 'my-offers' },
    { icon: 'fa-check-circle', label: 'My Work', path: 'active-work' },
    { icon: 'fa-building', label: 'Company Profile', path: 'company-profile' }
  ];

  const adminMenu = [
    { icon: 'fa-tachometer-alt', label: 'Dashboard', path: 'dashboard' },
    { icon: 'fa-user-check', label: 'Verify Service Providers', path: 'verify-service-providers' },
    { icon: 'fa-gavel', label: 'Disputes', path: 'disputes' },
    { icon: 'fa-chart-bar', label: 'Reports', path: 'reports' },
    { icon: 'fa-users', label: 'Users', path: 'users' },
    { icon: 'fa-cog', label: 'Settings', path: 'settings' }
  ];

  switch (userRole) {
    case 'owner': return ownerMenu;
    case 'service-provider': return serviceProviderMenu;
    case 'admin': return adminMenu;
    default: return ownerMenu;
  }
};

export const getSidebarFooter = (userRole) => {
  const footers = {
    owner: { icon: 'fa-map-marker-alt', label: 'Active Ports', value: 'Dubai • Singapore • Fujairah' },
    'service-provider': { icon: 'fa-building', label: 'Service Areas', value: 'Dubai • Singapore • Lagos' },
    admin: { icon: 'fa-shield-alt', label: 'Platform Status', value: 'All Systems Operational' }
  };
  return footers[userRole] || footers.owner;
};